import React, { useState } from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Modal from "@amzn/meridian/modal";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import plusKnockoutTokens from "@amzn/meridian-tokens/base/icon/plus-knockout";
import UpsertShift from "./UpsertShift";

const CreateShiftModal = ({ allShifts, dayOfWeek, onSubmit }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Column>
      <Row alignmentHorizontal="end" widths="fit">
        <Button onClick={() => setIsOpen(true)} type="tertiary">
          <Icon tokens={plusKnockoutTokens} />
          Add Shift
        </Button>
      </Row>
      <Modal
        title="New Shift"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        closeLabel="Close"
      >
        {isOpen && (
          <UpsertShift
            allShifts={allShifts}
            shift={{}}
            dayOfWeek={dayOfWeek}
            onSubmit={(daysOfWeek, shift) => onSubmit(daysOfWeek, {}, shift)}
            onCancel={() => setIsOpen(false)}
            isEdit={false}
          />
        )}
      </Modal>
    </Column>
  );
};
export default CreateShiftModal;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/ssd/CreateShiftModal.js